import * as Logger from '../libs/wa-logger.js';
import * as OnBigSmall from '../components/on-screen-big-small.js';
import * as Guards from "../libs/guards"
const $ = require('jquery');
const jqpt = require('../libs/jquery-powertip/dist/jquery.powertip.js'); // eslint-disable-line no-unused-vars
    
var mediaQuery_480 = window.matchMedia("(max-width: 480px)");
var mediaQuery_768 = window.matchMedia("(max-width: 768px)");
var mediaQuery_992 = window.matchMedia("(max-width: 992px)");
var mediaQuery_1200 = window.matchMedia("(max-width: 1200px)");

var mediaQuery_min_480 = window.matchMedia("(min-width: 480px)");
var mediaQuery_min_768 = window.matchMedia("(min-width: 768px)");
var mediaQuery_min_992 = window.matchMedia("(min-width: 992px)");
var mediaQuery_min_1200 = window.matchMedia("(min-width: 1200px)");
var screen_state = {
	is_small: false
}
function initial_screen_size(selector: string)
{
	// xcheck()
	if(mediaQuery_992) {
		screen_state.is_small = true;
		setup_small(selector)
	} else {
		screen_state.is_small = false;
		setup_big(selector)
	}
	// mediaQuery_480.addEventListener("change", (e) => {
	// 	console.log("480 listener")
	// })
	// mediaQuery_768.addEventListener("change", (e) => {
	// 	console.log("768 listener")
	// })
	// mediaQuery_1200.addEventListener("change", (e) => {
	// 	console.log("1200 listener")
	// })
	mediaQuery_992.addEventListener("change", (e) => {
		if(screen_state.is_small && (!e.matches)) {
			setup_big(selector)
			screen_state.is_small = false
		} else if((!screen_state.is_small) && (e.matches)) {
			setup_small(selector)
			screen_state.is_small = true
		} else {
			//not changing
		}
	})
	function setup_small(selector: string) {
		const sel = $(selector)
		console.log(['setup_small main menu called', selector, sel.length]);
		if(sel.length > 0) {
			console.log("is NOT already small")
			if(click_drop_menus) {
				largeMainMenuDropdownItems(false)
				smallMainMenuDropdownItems(true)
			}
			disableMainMenuPowertip(sel)
			setupMainMenuPowertip(sel, "e")
			setupHamburgerMainMenu()
		} else {
			console.log("is already small")
		}
	}
	function setup_big(selector: string) {
		// const has_powertip = ($('#powerTip').data('powerTip-open') !== undefined && $('#powerTip').data('powerTip-open') === 'yes');
		const is_hamburger = isHamburgerMainmenu()
		console.log(['setup_big main menu called', "is_hamburger: ", is_hamburger]);
		if (is_hamburger) {
			disableHamburgerMainMenu()
			if(click_drop_menus) {
				smallMainMenuDropdownItems(false)
				largeMainMenuDropdownItems(true)
			}
			disableMainMenuPowertip($(selector))
			setupMainMenuPowertip($(selector), "sw")
		}
	};

};


// function  xcheck()
// {
// 	const x1 = mediaQuery_480.matches
// 	const x2 = mediaQuery_768.matches
// 	const x3 = mediaQuery_992.matches
// 	const x4 = mediaQuery_1200.matches

// 	const y1 = mediaQuery_min_480.matches
// 	const y2 = mediaQuery_min_768.matches
// 	const y3 = mediaQuery_min_992.matches
// 	const y4 = mediaQuery_min_1200.matches
// 	console.log(`x1: ${x1} x2: ${x2} x3: ${x3} x4: ${x4}`)
// 	mediaQuery_480.addEventListener("change", (e) => {
// 		const x1 = mediaQuery_480.matches
// 		const x2 = mediaQuery_768.matches
// 		const x3 = mediaQuery_992.matches
// 		const x4 = mediaQuery_1200.matches
// 		console.log(`480 observer: x1: ${x1} x2: ${x2} x3: ${x3} x4: ${x4}`)
// 		const y1 = mediaQuery_min_480.matches
// 		const y2 = mediaQuery_min_768.matches
// 		const y3 = mediaQuery_min_992.matches
// 		const y4 = mediaQuery_min_1200.matches
// 		console.log(`480 observer: y1: ${y1} y2: ${y2} y3: ${y3} y4: ${y4}`)
// 	})
// 	mediaQuery_768.addEventListener("change", (e) => {
// 		const x1 = mediaQuery_480.matches
// 		const x2 = mediaQuery_768.matches
// 		const x3 = mediaQuery_992.matches
// 		const x4 = mediaQuery_1200.matches
// 		console.log(`768 observer: x1: ${x1} x2: ${x2} x3: ${x3} x4: ${x4}`)
// 		const y1 = mediaQuery_min_480.matches
// 		const y2 = mediaQuery_min_768.matches
// 		const y3 = mediaQuery_min_992.matches
// 		const y4 = mediaQuery_min_1200.matches
// 		console.log(`768 observer: y1: ${y1} y2: ${y2} y3: ${y3} y4: ${y4}`)
// 	})
// 	mediaQuery_992.addEventListener("change", (e) => {
// 		const x1 = mediaQuery_480.matches
// 		const x2 = mediaQuery_768.matches
// 		const x3 = mediaQuery_992.matches
// 		const x4 = mediaQuery_1200.matches
// 		console.log(`992 observer: x1: ${x1} x2: ${x2} x3: ${x3} x4: ${x4}`)
// 		const y1 = mediaQuery_min_480.matches
// 		const y2 = mediaQuery_min_768.matches
// 		const y3 = mediaQuery_min_992.matches
// 		const y4 = mediaQuery_min_1200.matches
// 		console.log(`992 observer: y1: ${y1} y2: ${y2} y3: ${y3} y4: ${y4}`)
// 	})
// 	mediaQuery_1200.addEventListener("change", (e) => {
// 		const x1 = mediaQuery_480.matches
// 		const x2 = mediaQuery_768.matches
// 		const x3 = mediaQuery_992.matches
// 		const x4 = mediaQuery_1200.matches
// 		console.log(`1200 observer: x1: ${x1} x2: ${x2} x3: ${x3} x4: ${x4}`)
// 		const y1 = mediaQuery_min_480.matches
// 		const y2 = mediaQuery_min_768.matches
// 		const y3 = mediaQuery_min_992.matches
// 		const y4 = mediaQuery_min_1200.matches
// 		console.log(`1200 observer: y1: ${y1} y2: ${y2} y3: ${y3} y4: ${y4}`)
// 	})
// }

/**
 * Options
 */
const click_drop_menus = true //in small mode have to click a dropdown menu for it to open - otherwise it opens on hover

export function setupMainMenu(selector: string, placement: string) {
	initial_screen_size(selector)
	return;
	// check();
	// function onGoingBig() {
	// 	// const has_powertip = ($('#powerTip').data('powerTip-open') !== undefined && $('#powerTip').data('powerTip-open') === 'yes');
	// 	const is_hamburger = isHamburgerMainmenu()
	// 	console.log(['onBig main menu called', "is_hamburger: ", is_hamburger]);
	// 	if (is_hamburger) {
	// 		disableHamburgerMainMenu()
	// 		if(click_drop_menus) {
	// 			smallMainMenuDropdownItems(false)
	// 			largeMainMenuDropdownItems(true)
	// 		}
	// 		disableMainMenuPowertip($(selector))
	// 		setupMainMenuPowertip($(selector), "sw")
	// 	}
	// };

	// function onGoingSmall() {
	// 	const sel = $(selector)
	// 	console.log(['onSmall main menu called', selector, sel.length]);
	// 	if(sel.length > 0) {
	// 		console.log("is NOT already small")
	// 		if(click_drop_menus) {
	// 			largeMainMenuDropdownItems(false)
	// 			smallMainMenuDropdownItems(true)
	// 		}
	// 		disableMainMenuPowertip(sel)
	// 		setupMainMenuPowertip(sel, "e")
	// 		setupHamburgerMainMenu()
	// 	} else {
	// 		console.log("is already small")
	// 	}
	// };
	// if(! click_drop_menus) {
	// 	largeMainMenuDropdownItems(true)// setupPowertip($(selector), placement)
	// }
	// OnBigSmall.register(onGoingBig, onGoingSmall);
	// OnBigSmall.start()
}

function isBigScreen() {

}
function hasPowertip() {
	const has_powertip = ($('#powerTip').data('powerTip-open') !== undefined && $('#powerTip').data('powerTip-open') === 'yes');
	return has_powertip
}
function isHamburgerMainmenu() {
	const $el = $("#navbarToCollapse")
	const r = $el.hasClass('collapse')
	return r
}
function disableMainMenuPowertip($elements: any) {
	$elements.powerTip('destroy');
	$('#powerTip').data('powerTip-open', 'no');
}
function setupMainMenuPowertip($elements: any, placement: string) {
	$('#powerTip').data('powerTip-open', 'yes').css('width:300px');
	$elements.powerTip({
		placement,
		smartPlacement:true, // placement, // eslint-disable-line object-shorthand
		fadeInTime: 0,
		fadeOutTime: 0,
		offset: 10,
	});
	$elements.on({
		powerTipPreRender: function powerTipPreRender() {
			$(this).data('powertip-open', 'yes');
			const text64 = $(this).attr('data-tooltip');
			const html = window.atob(text64)
			console.log('menu tooltip powerPreTipRender', html, text64, this);
			$(this).data('powertip', html);
		},
		powerTipRender : function PowerTipRender() {
			$('#powerTip').css('max-width', '400px');
			$('#powerTip').css('white-space', 'normal');
			Logger.log(['menu tooltip open', this, $('#powerTip')]);
		},
		powerTipOpen : function powerTipOpen() {
			Logger.log(['menu tooltip open', this, $('#powerTip')]);
		},
	});
}
function setupHamburgerMainMenu() {
	console.log("setup hamburger main-menu")
	const $hamburger_button = $("div.navbar-header > button")
	$hamburger_button.off('click');
	$hamburger_button.off('touchstart');
	let f = (ev: Event) => {
		console.log(['f: button on clicked or touched ', ev])
		const $el = $("#navbarToCollapse")
		if($el.hasClass('collapse')) {
			$el.removeClass('collapse')
		} else {
			$el.addClass('collapse')
		}
	}
	let ff = (ev: Event) => {
		console.log(['f: button touched ', ev])
		return;
		const $el = $("#navbarToCollapse")
		if($el.hasClass('collapse')) {
			$el.removeClass('collapse')
		} else {
			$el.addClass('collapse')
		}
	}
	$hamburger_button.on('touchstart', ff)
	$hamburger_button.on('click', f)
}
function disableHamburgerMainMenu() {
	console.log("disable hamburger main-menu")
	const $hamburger_button = $("div.navbar-header > button")
	$hamburger_button.off('click')
	$("#navbarToCollapse").addClass('collapse')
}
const handleExpand = (ev: Event) => {
	const t = ev.currentTarget as HTMLLIElement
	t.classList.add('open')
	console.log(["entered", ev])
}
const handleCollapse = (ev: Event) => {
	const t = ev.currentTarget as HTMLLIElement
	t.classList.remove('open')
	console.log(["leaving", ev])
}
/**
 * Enable or Disable the action that Expands(mouseenter) and/or Collapses(mouseexit) dropdowns in the main menu when the screen is 
 * Large
 */
function largeMainMenuDropdownItems(enable: boolean) {
	const dropdown_menu_items = document.querySelectorAll('.dropdown')

	if(enable) {
		dropdown_menu_items.forEach((el) => {
			const li_el = Guards.isHTMLLIElement(el)
			li_el.addEventListener("mouseenter", handleExpand)
			li_el.addEventListener("mouseleave", handleCollapse)
		})
	} else {
		dropdown_menu_items.forEach((el) => {
			const li_el = Guards.isHTMLLIElement(el)
			li_el.removeEventListener("mouseenter", handleExpand)
			li_el.removeEventListener("mouseleave", handleCollapse)
		})
	}
}
const handleClick = (ev: Event) => {
	const t = ev.currentTarget as HTMLLIElement
	if(t.classList.contains('open')) {
		console.log('close a dropdown')
		t.classList.remove('open')
	} else {
		console.log('open a dropdown')
		t.classList.add('open');
	}
}
/**
 * Enable or Disable the action that Expands(click) or Collapses (click) the dropdowns in the mainmenu when the 
 * screen is small 
 */
function smallMainMenuDropdownItems(enable: boolean) {
	const dropdown_menu_items = document.querySelectorAll('.dropdown')
	if(enable) {
		dropdown_menu_items.forEach((el) => {
			const li_el = Guards.isHTMLLIElement(el)
			li_el.addEventListener("click", handleClick)
		})
	} else {
		dropdown_menu_items.forEach((el) => {
			const li_el = Guards.isHTMLLIElement(el)
			li_el.removeEventListener("click", handleClick)
		})
	}
}
